import React from 'react';

function Location() {
  return (
    <div className='location'>
        <a 
          href="https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d14301.399903258285!2d43.9499155!3d26.3475401!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x157f59182f6ae165%3A0xfa55d268b1c0118f!2z2YXYsdmD2LIg2K_Zg9iq2YjYsSDZg9in2LEg2YTYtdmK2KfZhtipINin2YTYs9mK2KfYsdin2Ko!5e0!3m2!1sar!2ssa!4v1734185251279!5m2!1sar!2ssa" 
          target="_blank" 
          rel="noopener noreferrer"
        >
          <iframe 
            src="https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d14301.399903258285!2d43.9499155!3d26.3475401!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x157f59182f6ae165%3A0xfa55d268b1c0118f!2z2YXYsdmD2LIg2K_Zg9iq2YjYsSDZg9in2LEg2YTYtdmK2KfZhtipINin2YTYs9mK2KfYsdin2Ko!5e0!3m2!1sar!2ssa!4v1734185251279!5m2!1sar!2ssa" 
            width="100%" 
            height="450" 
            style={{ border: 0 }} 
            allowFullScreen="" 
            loading="lazy" 
            referrerPolicy="no-referrer-when-downgrade"
            title="Google Map"
          ></iframe>
        </a>
      </div>
  );
}

export default Location;
